"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { ProductPage } from "@/clients/contentful";
import { trackViewItemEvent } from "@/features/analytics";
import { ROUTES } from "@/features/store/settings/routes";

export function ProductViewedTracker({ product }: { product: ProductPage }) {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname && pathname.includes(`${ROUTES.PRODUCT}/`)) {
      trackViewItemEvent({ product });
    }
  }, [pathname]);

  return null;
}

ProductViewedTracker.displayName = "ProductViewedTracker";
